module.exports = __webpack_public_path__ + "img/qr-alipay.deaed341.svg";